
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.338 13.33a1.407 1.407 0 01-1.218 2.109H2.06a1.407 1.407 0 01-1.217-2.11l7.03-12.187a1.407 1.407 0 012.435 0l7.03 12.188zM9.09 10.81a1.348 1.348 0 100 2.695 1.348 1.348 0 000-2.695zM7.81 5.966l.218 3.984c.01.187.165.333.351.333h1.422c.187 0 .341-.146.351-.333l.218-3.984a.352.352 0 00-.351-.37H8.162a.352.352 0 00-.351.37z","fill":"#CC3434"}})])
          )
        }
      }
    